import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button, Stack, Modal } from "@mui/material";
import { Colors } from "../../../../Styles/Colors";
import { ImagePaths } from "../../../../Utility/ImagePaths";
import { CommonEditButton, CommonGridToolBarWithFilterText } from "../../../../Components/Common Components/CommonComponents";
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { CheckAccessFunc, ContentInTooltip, formatDate, formatDateAndTime, formatDateAndTimeMeth2 } from "../../../../Components/CommonFunctions/CommonFunctions";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { setCachevalue } from "../../../../Utility/Services/CacheProviderService";


function MembershipCardWiseReport(props) {
    const { loggedData } = props
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [auditData, setauditData] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [popOpen, setPopOpen] = useState(false);
    const [patientDetails, setPatientDetails] = useState([]);
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    let EditAccess = (CheckAccessFunc("Store", "Purchase", "Audit", null, "Tab")?.editAccess)


    useEffect(() => {
        if (location.states?.PackageData?.membership_card_details?.length) {
            let card_details = []
            location.states?.PackageData?.membership_card_details.forEach((element) => {
                let obj = {
                    ...element,
                    Period: `${element?.duration} ${element?.duration_mode}`
                }
                card_details.push(obj)
            })
            setauditData(card_details)
        }
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }


    const getAuditList = () => {
        try {
            // setisloader(true)
            // RestAPIService.getAll(Serviceurls.STORE_AUDIT_STOCK_HOME)
            //     .then((response) => {
            //         if (response.data.status === 'success') {
            //             setisloader(false)
            //             setauditData(response.data.data || [])
            //         }
            //     }).catch(e => {
            //         setisloader(false)
            //         if (e?.response?.data?.status === 'fail') {
            //             errorMessage(e.response.data.message)
            //         } else {
            //             errorMessage(e.message)
            //         }
            //     })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderModalOpen = () => {
        patientDetails?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            { field: 'sno', headerName: "S No", flex: 0.05, align: "center", headerAlign: "center" },
            {
                field: "patient_name", headerName: "Patient Name", flex: 0.08,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_name ? params?.row?.patient_name?.length > 30 ?
                    <Tooltip placement='top' title={params?.row?.patient_name} arrow><div>{params?.row?.patient_name.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.patient_name : "-"}</Box>)
            },
            {
                field: "patient_uhid", headerName: "UHID", flex: 0.07, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_uhid || "-"}</Box>)
            },
            {
                field: "patient_age", headerName: "Age", flex: 0.07, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_age || 0}</Box>)
            },
            {
                field: "patient_gender", headerName: "Gender", flex: 0.07, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_gender || "-"}</Box>)
            },
            {
                field: "expiry_date", headerName: "Expiry Date", flex: 0.07, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.expiry_date ? formatDate(params?.row?.expiry_date) : "-"}</Box>)
            },
        ];
        return (
            <Box>
                <Modal open={popOpen}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '60vw', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: '0.5vw' }}>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb>
                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                Member Details
                            </Typography>
                            <Button
                                onClick={() =>
                                    setPopOpen(false)
                                }
                            >
                                <Box
                                    component={'img'}
                                    src={ImagePaths.LabCloseButton.default}
                                    height={'1vw'}
                                    width={'1vw'}
                                    mr={'1vw'}
                                />
                            </Button>
                        </Box>
                        <Box sx={{ height: '62vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                            <DataGrid
                                rows={patientDetails}
                                columns={columns}
                                getRowId={(row) => row['sno']}
                                components={{
                                    NoRowsOverlay: () => (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                            {'No Records To Be Shown'}
                                        </Box>
                                    )
                                }}
                                headerHeight={40}
                                density='standard'
                                disableSelectionOnClick
                                loading={isloader}
                            />
                        </Box>
                    </Box>
                </Modal>
            </Box>
        )
    }

    const GetPrint = () => {
        try {
            RestAPIService.getAllPrint(Serviceurls.MEMBERSHIP_MEMBER_REPORT + `?export_type=pdf&package_id=${location.states?.PackageData?.package_id}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const GetMembershipCardPrint = (data) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.MEMBERSHIP_MEMBER_CARD_PRINT + `?summary_id=${data?.membership_card_id}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithFilterText />
                    </Box>
                )
            }

            auditData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                { field: 'sno', headerName: "S No", flex: 0.05, align: "center", headerAlign: "center" },
                {
                    field: "card_number", headerName: "Membership Details", flex: 0.08,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.card_number ? params?.row?.card_number?.length > 30 ?
                        <Tooltip placement='top' title={params?.row?.card_number} arrow><div>{params?.row?.card_number.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.card_number : "-"}</Box>)
                },
                {
                    field: "no_of_revisits", headerName: "No Of Revisits", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{`${params?.row?.availed_visit_count || 0} / ${params?.row?.no_of_revisits || 0}`}</Box>)
                },
                {
                    field: "no_of_members", headerName: "No Of Members", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.no_of_members || 0}</Box>)
                },
                {
                    field: "Period", headerName: "Period", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.Period || 0}</Box>)
                },
                {
                    field: "membership_start_date", headerName: "Start Date", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.membership_start_date ? formatDateAndTimeMeth2(params?.row?.membership_start_date) : "-"}</Box>)
                },
                {
                    field: "expiry_date", headerName: "Expiry Date", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.expiry_date ? formatDate(params?.row?.expiry_date) : "-"}</Box>)
                },
                {
                    field: "status", headerName: "Card Status", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => {
                        let card_status = params?.row?.status === "Active" ? "Active" : params?.row?.status === "In-Active" ? "In-Active" : "-"
                        let divColor = params?.row?.status === "Active" ? "#ECFFE9" : params?.row?.status === "In-Active" ? "#FFE9E9" : null;
                        let txtColor = params?.row?.status === "Active" ? "#1E972A" : params?.row?.status === "In-Active" ? "#B82121" : null;
                        return (
                            <Stack sx={{ paddingX: "0.4vw", paddingY: "0.2vw", borderRadius: "0.2vw", backgroundColor: divColor, border: `1px solid ${txtColor}`, width: '10vw', textAlign: 'center' }}>
                                <Typography sx={{ color: txtColor, fontSize: "0.9vw" }}>{card_status ? card_status : "-"}</Typography>
                            </Stack>
                        );
                    }
                },
                {
                    field: "action", headerName: "Action", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>
                        <CommonEditButton
                            disable={params?.row?.status === "In-Active" || !CheckAccessFunc("front_office", "Settings", "Membership Configuration", "Membership Creation", "SubTab")?.editAccess}
                            onClick={() => {
                                setCachevalue(true, "DisableAllActions")
                                history.push({ pathname: '/Settings/MembershipConfiguration/MembershipCreation', states: { PackageData: params?.row } })
                            }}
                        />
                        <IconButton className='eMed_usrconf_btn' onClick={() => {
                            setPopOpen(true)
                            setPatientDetails(params?.row?.members_details || [])
                        }}>
                            <img src={ImagePaths.StoreViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                        </IconButton>
                        <Tooltip title={"Print Membership Card"} placement="top" arrow>
                            <Button
                                onClick={() => { GetMembershipCardPrint(params?.row) }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={ImagePaths.PrintIcons.default} alt="print" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip>
                    </Box>)
                },
            ];
            return (
                <Box sx={{ height: '75.5vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={auditData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1vw' }}>
                    <Tooltip title="Back" placement='top' arrow>
                        <Button emed_tid="back_credit_bills" className='eMed_Filter_Btns' onClick={() => { history.push({ pathname: "/FOReports/PatientReport/MembershipReport" }) }} startIcon={<ChevronLeftIcon />}>
                            Back to Membership Reports Home
                        </Button>
                    </Tooltip>
                    <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                        <Typography>Package Name : </Typography>
                        <Typography sx={{ marginLeft: "1vw" }} fontWeight={600}>{ContentInTooltip(location.states?.PackageData?.package_name ? location.states?.PackageData?.package_name : "-", 60, "1vw", 600)}</Typography>
                    </Box>
                </Box>
                <Tooltip title={'Print'} placement="top">
                    <IconButton onClick={() => { GetPrint() }}          >
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
                    </IconButton>
                </Tooltip>
                {/* <Tooltip title={'Print'} placement="top">
          <IconButton>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ExportIcon.default} alt='filter' />
          </IconButton>
        </Tooltip> */}
            </Box>
            <Box>
                {tableView()}
            </Box>
            {
                (errorMsg && errorMsgText) ?
                    <ToastMsg
                        severity={'error'}
                        msg={errorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            {
                (successMsg && successMsgText) ?
                    <ToastMsg
                        severity={'success'}
                        msg={successMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {renderModalOpen()}
        </Box>
    );
};

export default MembershipCardWiseReport;
